import Typography from '@mui/material/Typography';

import { useFetchAllQueries } from 'shared/base/hooks/useFetchAllQueries';

import { mapLabelData } from '../../mappers';
import { ReportCardWrapper } from '../cardWrapper';
import { LabelLoader } from './labelLoader';
import { ReportCardVariantProps } from '../../types';

export const LabelReportCard = ({
  clearFilters,
  columnFormatter,
  description,
  query,
  sx,
  title,
}: ReportCardVariantProps) => {
  const queryResult = useFetchAllQueries(query);

  return (
    <ReportCardWrapper
      clearFilters={clearFilters}
      description={description}
      query={query.baseQuery}
      queryResult={queryResult}
      renderContent={(successfulResult) => {
        const mappedData = mapLabelData(successfulResult.data, columnFormatter);

        return (
          <Typography component="div" variant="h1">
            {mappedData}
          </Typography>
        );
      }}
      renderLoading={() => <LabelLoader />}
      sx={sx}
      title={title}
    />
  );
};
